const TOOL_ERROR_PATTERNS = [
  {
    pattern: /Saldo insuficiente para gerar as artes/i,
    key: 'campaignChat.tool.errors.insufficientArtsGenerate',
  },
  {
    pattern: /Saldo insuficiente para editar a arte/i,
    key: 'campaignChat.tool.errors.insufficientArtsEdit',
  },
  {
    pattern: /Saldo insuficiente para regenerar as artes/i,
    key: 'campaignChat.tool.errors.insufficientArtsRegenerate',
  },
  {
    pattern: /Saldo insuficiente/i,
    key: 'campaignChat.tool.errors.insufficientArts',
  },
  {
    pattern: /Limite de \d+ gerações de estratégia atingido/i,
    key: 'campaignChat.error.strategyGenerationLimit',
  },
];

/**
 * Maps backend tool error messages to i18n keys when recognized.
 * Falls back to the raw message or a generic error string.
 */
export function resolveToolErrorMessage(message, t) {
  if (!message || typeof message !== 'string') {
    return t('campaignChat.tool.error');
  }

  for (const {pattern, key} of TOOL_ERROR_PATTERNS) {
    if (pattern.test(message)) {
      return t(key);
    }
  }

  return message;
}
